import { NotificationService } from 'src/app/core/services/notification.service';

import {
  MAX_TESTS_PER_OPENING,
  MAX_TESTS_PER_OPENING_ERROR,
} from '../constants';

/**
 * The server's refusal of an opening larger than the cap.
 *
 * The forms already refuse this before it is sent, so reaching here means the
 * request came from somewhere the form's validator does not cover — a stale tab,
 * a direct API call. Handled anyway so the answer is the same sentence the field
 * gives rather than the generic "failed to create" the user cannot act on.
 *
 * Returns whether it recognised the error, so callers can fall through to their
 * own handling for anything else.
 */
export function handleTestsPerOpeningError(
  err: any,
  notificationService: NotificationService,
): boolean {
  if (err?.error?.message !== 'TEST_RECORDS.ERRORS.TOO_MANY_TESTS_PER_OPENING') {
    return false;
  }

  // The cap travels with the refusal so the two sides can move apart without this
  // message going stale; the local constant is only the fallback.
  const max = err?.error?.maxTestsPerOpening ?? MAX_TESTS_PER_OPENING;
  notificationService.error(
    max === MAX_TESTS_PER_OPENING
      ? MAX_TESTS_PER_OPENING_ERROR
      : `You can open up to ${max} tests at a time. To open more tests, create another opening.`,
  );
  return true;
}
